import * as Selectors  from './selectors';
import { useSelector } from 'react-redux';


// -- Business Hooks --

export function useBusiness(businessID) {
  return useSelector(state => Selectors.getBusiness(state, businessID));
}

export function useTeam(businessID) {
  return useSelector(state => Selectors.getTeam(state, businessID));
}

export function useBannerImage(businessID) {
  return useSelector(state => Selectors.getBannerImage(state, businessID));
}

export function useClassifySetting(businessID) {
  return useSelector(state => Selectors.getClassifySetting(state, businessID));
}

export function useNeedsOnboarding(businessID) {
  return useSelector(state => Selectors.needsOnboarding(state, businessID));
}
